import { Modal } from "components";
import type { ModalProps } from "components/Modal";
import type { ReactStoryblokComponent } from "types/storyblok";

export const ModalAdapter = ({
  blok: { buttonSize, buttonText, buttonVariant, content, modalSize, gtmSection, gtmElement, gaLabel, gaPlacement },
  sbEditable,
}: ReactStoryblokComponent<ModalProps>) => (
  <Modal
    buttonSize={buttonSize}
    buttonText={buttonText}
    buttonVariant={buttonVariant}
    content={content}
    modalSize={modalSize}
    gtmElement={gtmElement}
    gtmSection={gtmSection}
    gaLabel={gaLabel}
    gaPlacement={gaPlacement}
    sbEditable={sbEditable}
  />
);
